const { NUMBER } = require('../primitives');

const number = {
  ...NUMBER,
};
module.exports = number;
